module.exports = __webpack_public_path__ + "img/waiting-room.ce3f74b9.png";